import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";
import { showTranslated, translate } from "@/config/translator";
// eslint-disable-next-line max-len
import { useAttendanceMobileEditForm } from "./attendanceMobileEditForm/useAttendanceMobileEditForm";
// eslint-disable-next-line max-len
import { AttendancesMobileHeader } from "@/components/attendancesMobileHeader/attendancesMobileHeader";
import { formatDateFromLangLong } from "@/config/utils";
import Skeleton from "react-loading-skeleton";
import { AttendanceMobileHoursInput } from "./attendanceMobileEditForm/attendanceMobileHoursInput";
import { Fragment } from "react/jsx-runtime";
import {
  formatHours,
  onChangeTempAttendanceMonth,
  POSITIVE_GIUSTIFICATIVI,
} from "../../attendanceUtils";
import { PressableDashedBox } from "@/components/pressableDashedBox/pressableDashedBox";
// eslint-disable-next-line max-len
import { AddGiustificativoBottomSheet } from "./attendanceMobileEditForm/addGiustificativoBottomSheet";
import { faPlus } from "@fortawesome/pro-regular-svg-icons";
import ConfirmationDialog from "@/components/confirmationDialog/ConfirmationDialog";

export function AttendanceMobileEditForm() {
  const {
    lang,
    date,
    employee,
    giustificativi,
    tempAttendanceDay,
    onBlurGiustificativoInput,
    onBlurRegularHoursInput,
    currentScratchValue,
    setCurrentEditingValue,
    setCurrentScratchValue,
    setTempAttendanceMonth,
    employeeMatricola,
    employeeFiliale,
    isSaving,
    setIsSaving,
    isSubmitted,
    addGiustificativoBottomSheetOpen,
    setAddGiustificativoBottomSheetOpen,
    employeeAttendance,
    openRemoveGiustificativoConfirmation,
    closeRemoveGiustificativoConfirmation,
    removeGiustificativoConfirmationOpen,
    wantsToRemoveGiustificativo,
    onRemoveGiustificativo,
  } = useAttendanceMobileEditForm();

  return (
    <>
      <TopBarMobile headerString={translate("attendances", lang)} />
      <div className="p-6 flex flex-col gap-4">
        <AttendancesMobileHeader
          primaryText={translate("enterHours", lang)}
          secondaryText={
            <>
              {formatDateFromLangLong(date, lang)} -{" "}
              <span>{employee?.name ?? <Skeleton width={100} />}</span>
            </>
          }
        />

        <AttendanceMobileHoursInput
          label={translate("regularHours", lang)}
          disabled={isSaving || !!isSubmitted}
          onBlur={onBlurRegularHoursInput}
          onFocus={(event) => {
            setCurrentEditingValue(event.target.value);
            setCurrentScratchValue(event.target.value);
          }}
          onChange={(value) => setCurrentScratchValue(value)}
          value={
            currentScratchValue !== null
              ? currentScratchValue
              : tempAttendanceDay === undefined
                ? ""
                : formatHours(
                    Number.parseFloat(tempAttendanceDay.actualHours) -
                      tempAttendanceDay.giustificativi.reduce(
                        (sum, g) =>
                          !Number.isNaN(Number.parseFloat(g.hours))
                            // NOTE: claude suggested this line, I hope he's right
                            ? POSITIVE_GIUSTIFICATIVI.includes(g.type) ? sum : sum + Number.parseFloat(g.hours)
                            : sum,
                        0,
                      ),
                  )
          }
        />

        <div className="h-px bg-neutral -mx-2" />

        {/* GIUSTIFICATIVI */}
        {giustificativi?.map((g) => (
          <Fragment key={`edit-form-input-mobile-attendances-${g.type}`}>
            <AttendanceMobileHoursInput
              onRemove={() => openRemoveGiustificativoConfirmation(g)}
              onBlur={() => onBlurGiustificativoInput()}
              disabled={isSaving || !!isSubmitted}
              onChange={(value) =>
                onChangeTempAttendanceMonth(
                  setTempAttendanceMonth,
                  employeeMatricola,
                  employeeFiliale,
                  date.getDate() - 1,
                  value,
                  g.type,
                )
              }
              onFocus={(event) => setCurrentEditingValue(event.target.value)}
              label={`${g.type} - ${showTranslated(g.description, lang)}`}
              value={g.hours.replace(".", ",")}
            />

            <div className="h-px bg-neutral -mx-2" />
          </Fragment>
        ))}

        <PressableDashedBox
          onClick={() => setAddGiustificativoBottomSheetOpen(true)}
          icon={faPlus}
        >
          {translate("addGiustificativo", lang)}
        </PressableDashedBox>
      </div>
      {employeeAttendance && (
        <AddGiustificativoBottomSheet
          isOpen={addGiustificativoBottomSheetOpen}
          onClose={() => setAddGiustificativoBottomSheetOpen(false)}
          employeeAttendance={employeeAttendance}
          setIsSaving={setIsSaving}
        />
      )}
      {employeeAttendance && (
        <ConfirmationDialog
          isOpen={removeGiustificativoConfirmationOpen}
          onCancel={closeRemoveGiustificativoConfirmation}
          titleString={translate("areYouSure", lang)}
          onConfirm={onRemoveGiustificativo}
          messageString={translate("youAreAboutToRemoveGiustificativo", lang, {
            "{giustificativo}": wantsToRemoveGiustificativo
              ? `${wantsToRemoveGiustificativo.type} - ${wantsToRemoveGiustificativo.description}`
              : "",
            "{employeeName}": employeeAttendance.employee.name,
          })}
        />
      )}
    </>
  );
}
